/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import AREA_HIRARKI from "../site_selection/AREA_HIRARKI";
import AREA_SEARCH from "../site_selection/AREA_SEARCH";

/*REDUX*/
import {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
} from "../../App/actions/insight_v2";
import { run_gap } from "../../App/actions/gap_actions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const GAP_TOOL = ({
  //variable
  auth,
  gap_reducer,

  //function
  insight_reducer,
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
  run_gap,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const [state, setState] = useState({
    mode_input: "single_input", //hirarki || single_input
  });
  const { mode_input } = state;

  //global props

  useEffect(() => {
    const { list_tipe_1, list_tipe_2, list_tipe_3 } = insight_reducer;
    if (list_tipe_1.length === 0) {
      get_list_tipe_1();
    }
    if (list_tipe_2.length === 0) {
      get_list_tipe_2();
    }
    if (list_tipe_3.length === 0) {
      get_list_tipe_3();
    }
  }, [insight_reducer, get_list_tipe_1, get_list_tipe_2, get_list_tipe_3]);

  // Component did mount - set initial values
  useEffect(() => {
    set_value_insight({
      key: "tipe_level",
      value: "tipe_3",
    });

    set_value_insight({
      key: "tipe_3_array",
      value: [
        // {
        //   TIPE_1: "LAYANAN ATAU JASA",
        //   TIPE_2: "ATM",
        //   TIPE_3: "OCBC NISP",
        //   CODE_TIPE_1: "007",
        //   CODE_TIPE_2: "002",
        //   CODE_TIPE_3: "043",
        //   LAST_MID: "ID-007-002-043-0000244",
        //   count: 244,
        // },
        {
          TIPE_1: "LAYANAN ATAU JASA",
          TIPE_2: "BANK",
          TIPE_3: "OCBC NISP",
          CODE_TIPE_1: "007",
          CODE_TIPE_2: "003",
          CODE_TIPE_3: "058",
          LAST_MID: "ID-007-003-058-0000146",
          count: 146,
        },
      ],
    });
  }, [set_value_insight]); // Only run once on mount

  const on_set_mode_input = (mode_input) => {
    setState((prevState) => ({ ...prevState, mode_input }));
  };

  //content
  let input_area_content = <AREA_SEARCH />;
  if (mode_input === "hirarki") {
    input_area_content = <AREA_HIRARKI />;
  }

  return (
    <main>
      <section className="max_height">
        <h2 className="margin_bottom_extra">Gap Analysis OCBC</h2>
        <button
          className={`text_medium margin_right margin_bottom ${
            mode_input === "single_input" ? "underline_active" : "sub_color"
          }`}
          onClick={() => on_set_mode_input("single_input")}
        >
          {dict?.["Search"]?.[language]}
        </button>
        <button
          className={`text_medium margin_right margin_bottom ${
            mode_input === "hirarki" ? "underline_active" : "sub_color"
          }`}
          onClick={() => on_set_mode_input("hirarki")}
        >
          {dict?.["Administration Level"]?.[language]}
        </button>
        {input_area_content}
        <br />
        <br />
        <button
          className="button_big background_black"
          onClick={() => {
            run_gap();
          }}
        >
          Run Gap Tool
        </button>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  gap_reducer: state.gap_reducer,
  insight_reducer: state.insight_reducer,
});

export default connect(mapStateToProps, {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
  run_gap,
})(GAP_TOOL);
